export default __webpack_public_path__ + "static/media/DT-high-level.af90c96c.png";